// @flow
import styled from 'styled-components';
import { silverGrey } from '../../../colors';
/*::
import type { Node } from 'react';

export type ListThemeType = {|
  Main: * => Node,
  ItemWrapper: * => Node,
|};
*/

var DefaultTheme
/*: ListThemeType */
= {
  Main: styled.div.attrs({
    'data-cy': 'select-list-item-main'
  }).withConfig({
    displayName: "theme__Main",
    componentId: "sc-1nvbpaq-0"
  })([""]),
  ItemWrapper: styled.div.attrs({
    'data-cy': 'select-list-item-wrapper'
  }).withConfig({
    displayName: "theme__ItemWrapper",
    componentId: "sc-1nvbpaq-1"
  })(["border-bottom:1px solid ", ";"], silverGrey())
};
export default DefaultTheme;